import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    date,
    endDate,
    startDate,
    numberContract,
    firstTime,
    supplementaryForThe,
    taxAlternatePayerId,
    taxAlternatePayerName,
    taxId,
    taxAgencyName,
    taxAgentContract,
    taxAgentContractDate,

    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [date.name]: Yup.number().required(date.errorMsg),
  [startDate.name]: Yup.number().required(startDate.errorMsg),
  [endDate.name]: Yup.number().required(endDate.errorMsg),
  [numberContract.name]: Yup.string().required(numberContract.errorMsg),
  [taxAgentContractDate.name]: Yup.number().required(taxAgentContractDate.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxAlternatePayerId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAlternatePayerId.invalidMsg)
  .required(taxAlternatePayerId.errorMsg),
  [taxAlternatePayerName.name]: Yup.string().required(taxAlternatePayerName.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),

  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
